// Menu action header bar
export const buttonPermissions = {
  admin: [
    'Kích hoạt',
    'Chọn gói dịch vụ',
    'Chọn gói dịch vụ gia hạn',
    'Chuyển xuống đại lý',
    'Thu hồi',
    'Xóa'
  ],
  agency: ['Kích hoạt', 'Chọn gói dịch vụ', 'Chọn gói dịch vụ gia hạn', 'Chọn người bán', 'Thu hồi'],
  staff: ['Kích hoạt', 'Chọn gói dịch vụ'],
  enduser: ['Kích hoạt']
};

// Menu action right
export const menuPermissions = {
  admin: [
    'ACTIVATE',
    'SELECT_PACKAGE',
    'EDIT_DEVICE',
    'TRANSFER_AGENT',
    'EXTEND',
    'RECALL',
    'SELECT_SELLER',
    'DELETE'
  ],
  agency: [
    'ACTIVATE',
    'SELECT_PACKAGE',
    'EDIT_DEVICE',
    'EXTEND',
    'RECALL',
    'SELECT_SELLER',
  ],
  staff: ['ACTIVATE', 'EXTEND'],
  enduser: ['ACTIVATE']
};
